import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// const API_URL = environment.API_URL;

const API_URL = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class HttpApiService {

  constructor(
    private http: HttpClient,
  ) { }


  // getFilter(document: string, page: number, limit: number, filter: string): Observable<any> {
  //   const url = `${API_URL}/${document}?page=${page}&limit=${limit}&Filter=${filter}`;
  //   return this.http.get(url);
  // }

  // ----------------------------------------------------------- sign -----------------------------------------------------------

  /**
 * @brief 取得待簽核 list
 *
 * @param page 頁數(第幾頁的資料)
 * @param limit 個數(一頁有幾筆資料)
 * @return 回傳待簽核簽核資料
 */
  getSignListRequest(page: number, limit: number, filter: string, sort: string, filter_type): Observable<any> {
    const url = `${API_URL}/document-approval/pending?page=${page}&limit=${limit}&Filter=${filter}${sort}${filter_type}`;
    return this.http.get(url);
  }

  /**
 * @brief 取得已完成簽核 list
 *
 * @param page 頁數(第幾頁的資料)
 * @param limit 個數(一頁有幾筆資料)
 * @return 回傳已完成簽核資料
 */
  getFinishSignListRequest(page: number, limit: number, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/document-approval/finish?page=${page}&limit=${limit}&Filter=${filter}${sort}`;
    return this.http.get(url);
  }

  /**
  * @brief 取得歷史簽核(已送審)list
  *
  * @param page 頁數(第幾頁的資料)
  * @param limit 個數(一頁有幾筆資料)
  * @return 回傳歷史簽核(已送審)資料
  */
  getHistorySignListRequest(page: number, limit: number, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/document-approval/history?page=${page}&limit=${limit}&Filter=${filter}${sort}`;
    return this.http.get(url);
  }

  /**
  * @brief 簽核取消
  *
  * @param docu_approval_id 簽核單據的專屬 UUID
  * @return 回傳歷史簽核(已送審)資料
  */
  getUndoRequest(docu_approval_id: string): Observable<any> {
    const url = `${API_URL}/document-approval/cancel/${docu_approval_id}`;
    return this.http.get(url);
  }

  /**
  * @brief 簽核單據
  *
  * @param docu_approval_id 簽核單據的專屬 UUID
  * @param signRequest 簽核狀態的 json
  * @return 回傳是否簽核成功
  */
  signRequest(docu_approval_id: string, signRequest: any): Observable<any> {
    const url = `${API_URL}/document-approval/${docu_approval_id}`;
    return this.http.patch(url, signRequest);
  }

  /**
  * @brief 簽核退回呼叫備份
  *
  * @param document 簽核單據名稱
  * @param id 單據 UUID
  * @return 回傳是否備份成功
  */
  returnCopyRequest(document: string, id: string): Observable<any> {
    const url = `${API_URL}/${document}/copy-reject/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- download -----------------------------------------------------------

  /**
  * @brief 下載特定單據 pdf
  *
  * @param document 單據名稱 order/pi settelment ....
  * @param id 該單據的 UUID
  * @return 回傳下載 pdf 網址
  */
  downloadExcelRequest(document: string, id: string): Observable<any> {
    const url = `${API_URL}/${document}/create_excel/${id}`;
    return this.http.get(url);
  }

  /**
  * @brief 下載特定單據 excel
  *
  * @param document 單據名稱 order/pi settelment ....
  * @param id 該單據的 UUID
  * @return 回傳下載 excel 網址
  */
  downloadPdfRequest(document: string, id: string): Observable<any> {
    const url = `${API_URL}/${document}/create_pdf/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- PI/SP -----------------------------------------------------------
  // 取得全部PI
  getPiRequest(page: number, limit: number, status: string, creater_name: string, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/order?page=${page}&limit=${limit}&Filter=${filter}${sort}&FilterType=${status}&FilterCreaterName=${creater_name}`;
    return this.http.get(url);
  }

  // 取得全部SP
  getSpRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/order/sp?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 新增特定PI SP
  postOneOrderRequest(pispRequest: any): Observable<any> {
    const url = `${API_URL}/order`;
    return this.http.post(url, pispRequest);
  }

  // 取得特定PI/SP
  getOneOrderRequest(id: string): Observable<any> {
    const url = `${API_URL}/order/pisp/${id}`;
    return this.http.get(url);
  }

  // 複製特定PI/SP
  CopyPIRequest(id: string, cus_id: string): Observable<any> {
    const url = `${API_URL}/order/copy/${id}/${cus_id}`;
    return this.http.get(url);
  }

  // 取得特定刪除的單據
  getOneDelOrderRequest(id: string): Observable<any> {
    const url = `${API_URL}/order/pisp/${id}?del=1`;
    return this.http.get(url);
  }

  // 取得特定PI/SP廠商
  getOneOrderMFRequest(id: string): Observable<any> {
    const url = `${API_URL}/order/get-manufacturer/${id}`;
    return this.http.get(url);
  }

  // 取得訂單廠商的進貨單
  getOrderPMRequest(id: string): Observable<any> {
    const url = `${API_URL}/order/get-purchased-material/${id}`;
    return this.http.get(url);
  }

  // 取得特定PI SP
  // getOneOrderRequest_(id: string): Observable<any> {
  //   const url = `${API_URL}/order/pisp/${id}`;
  //   return this.http.get(url);
  // }

  // 修改特定PI SP
  patchOneOrderRequest(id: string, pispRequest: any): Observable<any> {
    const url = `${API_URL}/order/${id}`;
    return this.http.patch(url, pispRequest);
  }

  //刪除特定PI SP
  deleteOneOrderRequest(id: string): Observable<any> {
    const url = `${API_URL}/order/${id}`;
    return this.http.delete(url);
  }

  //取消特定PI SP
  cancelOneOrderRequest(id: string, review_id: string, reversed_reason: string): Observable<any> {

    let url: string
    if (reversed_reason) {
      url = `${API_URL}/document-approval/sign/cancel/order/${id}/${review_id}/${reversed_reason}`;
    } else {
      url = `${API_URL}/document-approval/sign/cancel/order/${id}/${review_id}`;
    }
    console.log('url', url)
    return this.http.get(url);
  }

  /**
* @brief 送審特定 Order
*
* @param id 單據 id
* @param review_id 複審業務 id
* @param reversed_reason 重審原因
* @return 回傳送審狀態
*/
  submitOneOrderRequest(id: string, review_id: string, reversed_reason: string): Observable<any> {

    console.log('單據 id', id, '複審業務 id', review_id, '重審原因', reversed_reason)
    let url: string
    if (reversed_reason) {
      //針對重審原因進行encodeURIComponent
      const encodedReason = encodeURIComponent(reversed_reason);
      url = `${API_URL}/document-approval/sign/order/${id}/${review_id}/${encodedReason}`;
    } else {
      url = `${API_URL}/document-approval/sign/order/${id}/${review_id}`;
    }
    console.log('url', url)
    return this.http.get(url);
  }

  // 設定 PI 關閉
  setPiClosed(id: string): Observable<any> {
    const url = `${API_URL}/order/set-closed/${id}`;
    return this.http.get(url);
  }

  // 取消 PI 開啟
  setPiReopen(id: string): Observable<any> {
    const url = `${API_URL}/order/set-reopen/${id}`;
    return this.http.get(url);
  }

  //下載特定 PI excel
  downloadOnePiExcelRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/pi/create_excel/${id}`;
    return this.http.get(url);
  }

  //下載特定 PI excel(中文)
  downloadOneChinesePiExcelRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/pi/create_chinese_excel/${id}`;
    return this.http.get(url);
  }

  //下載特定 PI pfd
  downloadOnePiPdfRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/pi/create_pdf/${id}`;
    return this.http.get(url);
  }

  //下載特定 PI pfd(中文)
  downloadOneChinesePiPdfRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/pi/create_chinese_pdf/${id}`;
    return this.http.get(url);
  }

  //下載特定 SP pdf
  downloadOneSpExcelRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/sp/create_excel/${id}`;
    return this.http.get(url);
  }

  //下載特定 SP excel
  downloadOneSpPdfRequest(id: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/sp/create_pdf/${id}`;
    return this.http.get(url);
  }

  //下載特定 SP 佣金單
  downloadOneCommissionRequest(id: string, name: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/commission/create_excel/${id}/${name}`;
    return this.http.get(url);
  }

  // 合併 PI SP 項目
  mergePISPItemRequest(pispRequest: any): Observable<any> {
    const url = `${API_URL}/order/get-sp-items`;
    return this.http.post(url, pispRequest);
  }

  // ----------------------------------------------------------- PO -----------------------------------------------------------

  // 取得全部PO
  getPoRequest(page: number, limit: number, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/purchase-order?page=${page}&limit=${limit}&Filter=${filter}${sort}`;
    return this.http.get(url);
  }

  // 取得order已PO
  getOrderPoRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/order/po?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得order已POitems
  getOrderPoItemsRequest(id: number): Observable<any> {
    const url = `${API_URL}/order/${id}`;
    return this.http.get(url);
  }

  // 取得特定PO
  getOnePoRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/${id}`;
    return this.http.get(url);
  }

  // 複製特定 PO
  CopyPORequest(id: string, poRequest: any): Observable<any> {
    const url = `${API_URL}/purchase-order/copy/${id}`;
    return this.http.post(url, poRequest);
  }

  // 取得特定刪除的單據
  getOneDelPORequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/${id}?del=1`;
    return this.http.get(url);
  }

  // 新增特定PO
  postOnePORequest(poRequest: any): Observable<any> {
    const url = `${API_URL}/purchase-order`;
    return this.http.post(url, poRequest);
  }

  // 修改特定PO
  patchOnePORequest(id: string, poRequest: any): Observable<any> {
    const url = `${API_URL}/purchase-order/${id}`;
    return this.http.patch(url, poRequest);
  }

  //刪除特定 PO
  deleteOnePORequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/${id}`;
    return this.http.delete(url);
  }

  // 送審特定PO
  submitOnePoRequest(id: string, review_id: string): Observable<any> {
    const url = `${API_URL}/document-approval/sign/purchase-order/${id}/${review_id}`;
    return this.http.get(url);
  }

  //下載特定 PO excel
  downloadOnePoExcelRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/create_excel/${id}`;
    return this.http.get(url);
  }

  //下載特定 PO pdf
  downloadOnePoPdfRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/create_pdf/${id}`;
    return this.http.get(url);
  }

  //下載特定 PO 採購單excel
  downloadOnePoPrExcelRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/create_excel_pr/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- CI -----------------------------------------------------------
  // 取得全部CI
  getCiRequest(page: number, limit: number, filter: string, sort: string, status: string): Observable<any> {
    const url = `${API_URL}/commercial-invoice?page=${page}&limit=${limit}&Filter=${filter}${sort}&FilterType=${status}`;
    return this.http.get(url);
  }

  // 取得全部提單資料
  getBillOfLadingRequest(page: number, limit: number, filter: string, sort: string, status: string): Observable<any> {
    const url = `${API_URL}/commercial-invoice/get-bill-of-lading?page=${page}&limit=${limit}&Filter=${filter}${sort}&FilterType=${status}`;
    return this.http.get(url);
  }

  // 取得已經設定開船日、尾款日的CI
  getCiAlreadyRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/commercial-invoice/for-settlement-sheet?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定PO
  getOneCiRequest(id: string): Observable<any> {
    const url = `${API_URL}/commercial-invoice/${id}`;
    return this.http.get(url);
  }

  // 新增特定CI
  postOneCiRequest(ciRequest: any): Observable<any> {
    const url = `${API_URL}/commercial-invoice`;
    return this.http.post(url, ciRequest);
  }

  // 修改特定CI
  patchOneCiRequest(id: string, ciRequest: any): Observable<any> {
    const url = `${API_URL}/commercial-invoice/${id}`;
    return this.http.patch(url, ciRequest);
  }

  // 取得要綁定的PO項目
  getPoItemsRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchase-order/get-unallocated?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //刪除特定CI
  deleteOneCiRequest(id: string): Observable<any> {
    const url = `${API_URL}/commercial-invoice/${id}`;
    return this.http.delete(url);
  }

  /**
  * @brief 送審特定 CI - 財務
  *
  * @param id CI 的 UUID
  * @return 回傳是否簽核成功
  */
  submitOneCiRequest(id: string): Observable<any> {
    const url = `${API_URL}/document-approval/sign/commercial-invoice/${id}`;
    return this.http.get(url);
  }

  /**
 * @brief 送審特定 CI - 船務
 *
 * @param id CI 的 UUID
 * @param ship_id 船務 的 UUID
 * @return 回傳是否簽核成功
 */
  submitOneCiShipRequest(id: string, ship_id: string): Observable<any> {
    const url = `${API_URL}/document-approval/sign/commercial-invoice-individual/${id}/${ship_id}`;
    return this.http.get(url);
  }

  /**
   * @brief 查看CI單號是否有重複
   *
   * @param invoice_no CI 的單號
   * @return 回傳是否有重複單號
   */
  checkCIRequest(invoice_no: string): Observable<any> {
    const url = `${API_URL}/commercial-invoice/check/${invoice_no}`;
    return this.http.get(url);
  }


  // ----------------------------------------------------------- purchased-material -----------------------------------------------------------
  // 取得全部purchased-material
  getPurchasedRequest(page: number, limit: number, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/purchased-material?page=${page}&limit=${limit}&Filter=${filter}${sort}`;
    return this.http.get(url);
  }

  // 取得全部PI/SP已結案之purchased-material
  getPurchasedApprovalRequest(page: number, limit: number, filter: string, sort: string, ordNum: string): Observable<any> {
    const url = `${API_URL}/purchased-material/get-approval?page=${page}&limit=${limit}&Filter=${filter}${sort}&ord_num=${ordNum}`;
    return this.http.get(url);
  }

  // 取得特定purchased-material
  getOnePurchasedRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchased-material/${id}`;
    return this.http.get(url);
  }

  // 新增特定purchased-material
  postOnePurchasedRequest(ciRequest: any): Observable<any> {
    const url = `${API_URL}/purchased-material`;
    return this.http.post(url, ciRequest);
  }

  // 修改特定purchased-material
  patchOnePurchasedRequest(id: string, ciRequest: any): Observable<any> {
    const url = `${API_URL}/purchased-material/${id}`;
    return this.http.patch(url, ciRequest);
  }

  // 取得未進貨的項目
  getUnpurchaseItemsRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchase-order/get-unpurchased?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定 PM 的廠商
  getPayableMFRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchased-material/get-accounts-payable-manufacturer/${id}`;
    return this.http.get(url);
  }


  /**
  * @brief 取得特定 PM 的廠商 Item
  *
  * @param pm_id 進貨單 UUID
  * @param m_id 進貨單廠商 UUID
  * @return 回傳該進貨單廠商的 Item
  */
  getPayableMFItemRequest(pm_id: string, m_id: string): Observable<any> {
    const url = `${API_URL}/purchased-material/get-accounts-payable-items/${pm_id}/${m_id}`;
    return this.http.get(url);
  }

  //刪除特定PI SP
  deleteOnePurchasedRequest(id: string): Observable<any> {
    const url = `${API_URL}/purchased-material/${id}`;
    return this.http.delete(url);
  }


  // ----------------------------------------------------------- invoice -----------------------------------------------------------
  // 取得全部invoice
  getInvoiceRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/invoice?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定invoice
  getOneInvoiceRequest(id: string): Observable<any> {
    const url = `${API_URL}/invoice/${id}`;
    return this.http.get(url);
  }

  // 新增進貨單invoice
  postOneInvoiceRequest(CLRequest: any): Observable<any> {
    const url = `${API_URL}/invoice`;
    return this.http.post(url, CLRequest);
  }

  // 新增訂金invoice
  postOneInvoiceByDepositRequest(CLRequest: any): Observable<any> {
    const url = `${API_URL}/invoice/pi`;
    return this.http.post(url, CLRequest);
  }

  // 修改特定invoice
  patchOneInvoiceRequest(id: string, CLRequest: any): Observable<any> {
    const url = `${API_URL}/invoice/${id}`;
    return this.http.patch(url, CLRequest);
  }

  // 取得應付帳款 item
  getPayablelistRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchased-material/has-accounts-payable?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得多選 PI 後的 PM
  getPMbyOrderRequest(OrderRequest: any): Observable<any> {
    const url = `${API_URL}/purchased-material/get-by-order`;
    return this.http.post(url, OrderRequest);
  }

  // 刪除特定請款單
  deleteOneInvoiceRequest(id: string): Observable<any> {
    const url = `${API_URL}/invoice/${id}`;
    return this.http.delete(url);
  }

  // 送審特定請款單
  submitOneInvoiceRequest(id: string): Observable<any> {
    const url = `${API_URL}/document-approval/sign/invoice/${id}`;
    return this.http.get(url);
  }

  // 下載特定 Invoice pdf
  downloadOneInvoiceExcelRequest(id: string): Observable<any> {
    const url = `${API_URL}/invoice/create_excel/${id}`;
    return this.http.get(url);
  }

  // 下載特定 Invoice excel
  downloadOneInvoicePdfRequest(id: string): Observable<any> {
    const url = `${API_URL}/invoice/create_pdf/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- analysis-variances -----------------------------------------------------------
  // 取得全部差異表
  getAnalysisVariancesRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/analysis-variances?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定差異表 by 月份
  getOneSettlementByMonthRequest(page: number, limit: number, year: number, month: number): Observable<any> {
    const url = `${API_URL}/analysis-variances?page=${page}&limit=${limit}&year=${year}&month=${month}`;
    return this.http.get(url);
  }

  // 取得特定差異表
  getOneAnalysisVariancesRequest(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/${id}`;
    return this.http.get(url);
  }

  // 新增特定差異表
  postOneAnalysisVariancesRequest(AVRequest: any): Observable<any> {
    const url = `${API_URL}/analysis-variances`;
    return this.http.post(url, AVRequest);
  }

  // 修改特定差異表
  patchOneAnalysisVariancesRequest(id: string, AVRequest: any): Observable<any> {
    const url = `${API_URL}/analysis-variances/${id}`;
    return this.http.patch(url, AVRequest);
  }

  //刪除特定差異表
  deleteOneAnalysisVariancesRequest(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/${id}`;
    return this.http.delete(url);
  }

  // 送審特定差異表
  submitOneAnalysisVariancesRequest(id: string): Observable<any> {
    const url = `${API_URL}/document-approval/sign/analysis-variances/${id}`;
    return this.http.get(url);
  }

  //下載差異表 pdf
  downloadAVExcelRequest(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/create_excel/${id}`;
    return this.http.get(url);
  }

  //下載差異表 excel
  downloadAVPdfRequest(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/create_pdf/${id}`;
    return this.http.get(url);
  }

  // 設定 差異表 關閉
  setAVClosed(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/set-closed/${id}`;
    return this.http.get(url);
  }

  // 取消 PI 開啟
  setAVReopen(id: string): Observable<any> {
    const url = `${API_URL}/analysis-variances/set-reopen/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- settlement -----------------------------------------------------------
  // 取得全部settlement
  getSettlementRequest(page: number, limit: number, filter: string, sort: string): Observable<any> {
    const url = `${API_URL}/settlement-sheet?page=${page}&limit=${limit}&Filter=${filter}${sort}`;
    return this.http.get(url);
  }

  // 取得特定settlement
  getOneSettlementRequest(id: string): Observable<any> {
    const url = `${API_URL}/settlement-sheet/${id}`;
    return this.http.get(url);
  }

  // 新增特定settlement
  postOneSettlementRequest(SettlementRequest: any): Observable<any> {
    const url = `${API_URL}/settlement-sheet`;
    return this.http.post(url, SettlementRequest);
  }

  // 修改特定settlement
  patchOneSettlementRequest(id: string, SettlementRequest: any): Observable<any> {
    const url = `${API_URL}/settlement-sheet/${id}`;
    return this.http.patch(url, SettlementRequest);
  }

  //刪除特定結算表
  deleteOneSettlementRequest(id: string): Observable<any> {
    const url = `${API_URL}/settlement-sheet/${id}`;
    return this.http.delete(url);
  }

  // 送審特定結算表
  // submitOneSettlementRequest(id: string): Observable<any> {
  //   const url = `${API_URL}/document-approval/sign/settlement-sheet/${id}`;
  //   return this.http.get(url);
  // }

  /**
  * @brief 送審特定結算表
  *
  * @param id 單據 id
  * @param reversed_reason 重審原因
  * @return 回傳送審狀態
  */
  submitOneSettlementRequest(id: string, reversed_reason: string): Observable<any> {

    console.log('單據 id', id, '重審原因', reversed_reason)

    let url: string
    if (reversed_reason) {
      url = `${API_URL}/document-approval/sign/settlement-sheet/${id}//${reversed_reason}`;
    } else {
      url = `${API_URL}/document-approval/sign/settlement-sheet/${id}`;
    }
    console.log('url', url)
    return this.http.get(url);
  }

  //下載特定 settlement pdf
  downloadOneSettlementExcelRequest(id: string): Observable<any> {
    const url = `${API_URL}/settlement-sheet/create_excel/${id}`;
    return this.http.get(url);
  }

  //下載特定 settlement excel
  downloadOneSettlementPdfRequest(id: string): Observable<any> {
    const url = `${API_URL}/settlement-sheet/create_pdf/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- client -----------------------------------------------------------

  // 取得全部client
  getClientRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/customer?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定client
  getOneClientRequest(id: string): Observable<any> {
    const url = `${API_URL}/customer/${id}`;
    return this.http.get(url);
  }

  // 新增特定client
  postOneClientRequest(CLRequest: any): Observable<any> {
    const url = `${API_URL}/customer`;
    return this.http.post(url, CLRequest);
  }

  // 修改特定client
  patchOneClientRequest(id: string, CLRequest: any): Observable<any> {
    const url = `${API_URL}/customer/${id}`;
    return this.http.patch(url, CLRequest);
  }

  // 刪除特定client
  deleteOneClientRequest(id: string): Observable<any> {
    const url = `${API_URL}/customer/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- 預收付 -----------------------------------------------------------
  // 取得全部預收付
  getOrderOverviewRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/order/overview?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得一段時間的預收付
  getOrderOverviewByDayRequest(page: number, limit: number, start: string, end: string): Observable<any> {
    const url = `${API_URL}/order/overview?page=${page}&limit=${limit}&start=${start}&end=${end}`;
    return this.http.get(url);
  }

  //下載全部 預收付 pdf
  downloadOneOverviewPdfRequest(page: number, limit: number): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/overview/create_pdf?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //下載全部 預收付 excel
  downloadOneOverviewExcelRequest(page: number, limit: number): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/overview/create_excel?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //下載一段時間的 預收付 pdf
  downloadOneOverviewPdfByDayRequest(page: number, limit: number, start: string, end: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/overview/create_pdf?page=${page}&limit=${limit}&start=${start}&end=${end}`;
    return this.http.get(url);
  }

  //下載一段時間的 預收付 excel
  downloadOneOverviewExcelByDayRequest(page: number, limit: number, start: string, end: string): Observable<any> {
    // const url = `${API_URL}}/order/pi/create_excel/${id}`;
    const url = `${API_URL}/order/overview/create_excel?page=${page}&limit=${limit}&start=${start}&end=${end}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- 庫存 -----------------------------------------------------------
  // 取得現有庫存
  getPoUnallocated(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchase-order/get-unallocated?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得全部庫存
  getAllPoUnallocated(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchase-order/get-unallocated-all?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得強制分配庫存
  getForcePoUnallocated(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/purchase-order/get-unallocated-force?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 設定庫存強制分配
  setPoAllocated(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/set-po-allocated/${id}`;
    return this.http.get(url);
  }

  // 取消庫存強制分配
  setForcePoUnallocated(id: string): Observable<any> {
    const url = `${API_URL}/purchase-order/set-po-unallocated/${id}`;
    return this.http.get(url);
  }

  // ----------------------------------------------------------- manufacturer -----------------------------------------------------------
  // 取得全部manufacturer
  getManufacturerRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/manufacturer?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定manufacturer
  getOneManufacturerRequest(id: string): Observable<any> {
    const url = `${API_URL}/manufacturer/${id}`;
    return this.http.get(url);
  }

  // 新增特定manufacturer
  postOneManufacturerRequest(MFRequest: any): Observable<any> {
    const url = `${API_URL}/manufacturer`;
    return this.http.post(url, MFRequest);
  }

  // 修改特定manufacturer
  patchOneManufacturerRequest(id: string, MFRequest: any): Observable<any> {
    const url = `${API_URL}/manufacturer/${id}`;
    return this.http.patch(url, MFRequest);
  }

  // 刪除特定client
  deleteOneManufacturerRequest(id: string): Observable<any> {
    const url = `${API_URL}/manufacturer/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- Beneficiary -----------------------------------------------------------
  // 取得全部 Beneficiary
  getBeneficiaryRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/beneficiary-info?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定 Beneficiary
  getOneBeneficiaryRequest(id: string): Observable<any> {
    const url = `${API_URL}/beneficiary-info/${id}`;
    return this.http.get(url);
  }

  // 新增特定 Beneficiary
  postBeneficiaryRequest(BFRequest: any): Observable<any> {
    const url = `${API_URL}/beneficiary-info`;
    return this.http.post(url, BFRequest);
  }

  // 修改特定 Beneficiary
  patchBeneficiaryRequest(id: string, BFRequest: any): Observable<any> {
    const url = `${API_URL}/beneficiary-info/${id}`;
    return this.http.patch(url, BFRequest);
  }

  // 刪除特定 Beneficiary
  deleteBeneficiaryRequest(id: string): Observable<any> {
    const url = `${API_URL}/beneficiary-info/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- RBAC -----------------------------------------------------------
  // 取得全部RBAC
  getRBACRequest(): Observable<any> {
    const url = `${API_URL}/policy`;
    return this.http.get(url);
  }

  // 取得使用者RBAC
  getUserRBACRequest(): Observable<any> {
    const url = `${API_URL}/policy/user`;
    return this.http.get(url);
  }

  // 新增特定RBAC
  postRBACRequest(RBACRequest: any): Observable<any> {
    const url = `${API_URL}/policy`;
    return this.http.post(url, RBACRequest);
  }

  // 刪除特定RBAC
  deleteRBACRequest(): Observable<any> {
    const url = `${API_URL}/policy`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- account -----------------------------------------------------------
  // 取得全部 account
  getUserRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/account?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  // 取得特定 account
  getOneUserRequest(id: string): Observable<any> {
    const url = `${API_URL}/account/${id}`;
    return this.http.get(url);
  }

  //取得特定 department account
  getUserByDepartmentRequest(dep_id: string): Observable<any> {
    const url = `${API_URL}/account/show-dep-user/${dep_id}`;
    return this.http.get(url);
  }

  // 新增特定 account
  postUserRequest(UserRequest: any): Observable<any> {
    const url = `${API_URL}/account`;
    return this.http.post(url, UserRequest);
  }

  // 修改特定 account
  patchUserRequest(id: string, UserRequest: any): Observable<any> {
    const url = `${API_URL}/account/${id}`;
    return this.http.patch(url, UserRequest);
  }

  // 刪除特定 account
  deleteUserRequest(id: string): Observable<any> {
    const url = `${API_URL}/account/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- department -----------------------------------------------------------
  //取得全部 department
  getDepartmentRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/department?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //取得特定 department
  getOneDepartmentRequest(id: string): Observable<any> {
    const url = `${API_URL}/department/${id}`;
    return this.http.get(url);
  }

  //新增特定 department
  postDepartmentRequest(DepartmentRequest: any): Observable<any> {
    const url = `${API_URL}/department`;
    return this.http.post(url, DepartmentRequest);
  }

  //修改特定department
  patchDepartmentRequest(id: string, DepartmentRequest: any): Observable<any> {
    const url = `${API_URL}/department/${id}`;
    return this.http.patch(url, DepartmentRequest);
  }
  // ----------------------------------------------------------- BPM -----------------------------------------------------------

  //取得全部BPM
  getBPMRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/bonita/process?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //取得特定BPM
  getOneBPMRequest(id: string): Observable<any> {
    const url = `${API_URL}/bonita/process/${id}`;
    return this.http.get(url);
  }

  //新增特定BPM
  postBPMRequest(BPMRequest: any): Observable<any> {
    const url = `${API_URL}/bonita/process`;
    return this.http.post(url, BPMRequest);
  }

  //修改特定BPM
  patchBPMRequest(id: string, BPMRequest: any): Observable<any> {
    const url = `${API_URL}/bonita/process/${id}`;
    return this.http.patch(url, BPMRequest);
  }

  getPCRequest(page: number, limit: number, country: string, contract_id: string, start: string, end: string, filter: string, sort: string, has_purchase?: number, client_id?: string): Observable<any> {

    // console.log(page, limit, country, contract_id, start, end)
    let url = `${API_URL}/order/pc?page=${page}&limit=${limit}`;

    if (country) url += `&country_search=${country}`;
    if (contract_id) url += `&contract_id_search=${contract_id}`;
    if (start) url += `&start=${start}`;
    if (end) url += `&end=${end}`;
    if (filter) url += `&Filter=${filter}`;
    if (sort) url += sort;
    if (has_purchase !== undefined && has_purchase !== null) url += `&has_purchase=${has_purchase}`;
    if (client_id !== undefined && client_id !== null) url += `&client_id=${client_id}`;
    // console.log(url)
    return this.http.get(url);
  }

  getOrderCreatePCExcel(page: number, limit: number, country: string, contract_id: string, start: string, end: string, filter: string, sort: string, has_purchase?: number, client_id?: string): Observable<any> {

    // console.log(page, limit, country, contract_id, start, end)
    let url = `${API_URL}/order/create-pc-excel?page=${page}&limit=${limit}`;

    if (country) url += `&country_search=${country}`;
    if (contract_id) url += `&contract_id_search=${contract_id}`;
    if (start) url += `&start=${start}`;
    if (end) url += `&end=${end}`;
    if (filter) url += `&Filter=${filter}`;
    if (sort) url += sort;
    if (has_purchase !== undefined && has_purchase !== null) url += `&has_purchase=${has_purchase}`;
    if (client_id !== undefined && client_id !== null) url += `&client_id=${client_id}`;
    // console.log(url)
    return this.http.get(url);
  }

  getOrderCreateCusExcel(): Observable<any> {
    let url = `${API_URL}/customer/excel`;
    // console.log(url)
    return this.http.get(url);
  }

  // 取得生管詳細資料
  getPCDetailRequest(o_id: string, page: number, limit: number): Observable<any> {
    return this.http.get(`${API_URL}/order/pc-detail?o_id=${o_id}&page=${page}&limit=${limit}`);
  }

  getPCamountRequest(page: number, limit: number, country: string, contract_id: string, start: string, end: string, filter: string, has_purchase?: number, client_id?: string): Observable<any> {

    // console.log(page, limit, country, contract_id, start, end)
let url = `${API_URL}/order/pc-amount?page=${page}&limit=${limit}`;

    if (country) url += `&country_search=${country}`;
    if (contract_id) url += `&contract_id_search=${contract_id}`;
    if (start) url += `&start=${start}`;
    if (end) url += `&end=${end}`;
    if (filter) url += `&filter=${filter}`;
    if (has_purchase !== undefined && has_purchase !== null) url += `&has_purchase=${has_purchase}`;
    if (client_id !== undefined && client_id !== null) url += `&client_id=${client_id}`;
    // console.log(url)
    return this.http.get(url);
  }

  // ----------------------------------------------------------- ROLE -----------------------------------------------------------
  //取得全部ROLE
  getRoleRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/role?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //取得特定ROLE
  getOneRoleRequest(id: string): Observable<any> {
    const url = `${API_URL}/role/${id}`;
    return this.http.get(url);
  }

  //新增特定ROLE
  postRoleRequest(RoleRequest: any): Observable<any> {
    const url = `${API_URL}/role`;
    return this.http.post(url, RoleRequest);
  }

  //修改特定ROLE
  patchRoleRequest(id: string, RoleRequest: any): Observable<any> {
    const url = `${API_URL}/role/${id}`;
    return this.http.patch(url, RoleRequest);
  }

  //刪除特定ROLE
  deleteRoleRequest(id: string): Observable<any> {
    const url = `${API_URL}/role/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- file -----------------------------------------------------------
  // 取得 order 的 file
  getFileRequest(page: number, limit: number, id: string): Observable<any> {
    const url = `${API_URL}/file?page=${page}&limit=${limit}&order_uuid=${id}`;
    return this.http.get(url);
  }

  // 取得 account 的 file
  getSignFileRequest(page: number, limit: number, id: string): Observable<any> {
    const url = `${API_URL}/file?page=${page}&limit=${limit}&account_id=${id}`;
    return this.http.get(url);
  }

  // 新增特定 file
  postFileRequest(fileRequest: any): Observable<any> {
    const url = `${API_URL}/file`;
    return this.http.post(url, fileRequest);
  }

  //取得全部FileRecovery
  getFileRecoveryRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/file?page=${page}&limit=${limit}&del=1`;
    return this.http.get(url);
  }
  //修改特定FileRecovery
  patchFileRecoveryRequest(id: string, is_deleted: any): Observable<any> {
    const url = `${API_URL}/file/${id}`;
    return this.http.patch(url, is_deleted);
  }

  // 刪除特定 file
  deleteFileRequest(id: string): Observable<any> {
    const url = `${API_URL}/file/${id}`;
    return this.http.delete(url);
  }

  // ----------------------------------------------------------- OperationFunction -----------------------------------------------------------
  //取得全部OperationFunction
  getOperationFunctionRequest(page: number, limit: number): Observable<any> {
    const url = `${API_URL}/operation-function?page=${page}&limit=${limit}`;
    return this.http.get(url);
  }

  //取得特定OperationFunction
  getOneOperationFunctionRequest(id: string): Observable<any> {
    const url = `${API_URL}/operation-function/${id}`;
    return this.http.get(url);
  }

  //新增特定OperationFunction
  postOperationFunctionRequest(OperationFunctionRequest: any): Observable<any> {
    const url = `${API_URL}/operation-function`;
    return this.http.post(url, OperationFunctionRequest);
  }

  //修改特定OperationFunction
  patchOperationFunctionRequest(id: string, OperationFunctioneRequest: any): Observable<any> {
    const url = `${API_URL}/operation-function/${id}`;
    return this.http.patch(url, OperationFunctioneRequest);
  }

  //刪除特定OperationFunction
  deleteOperationFunctionRequest(id: string): Observable<any> {
    const url = `${API_URL}/operation-function/${id}`;
    return this.http.delete(url);
  }



}


